import React from "react";
import "../css/WizardSidebar.scss";

class WizardSidebar extends React.Component {
	render() {
		return (
			<div className="wizard-sidebar">
				<div className="wizard-sidebar-content transition-container">
					<div className="wizard-sidebar-text">
						<div className="wizard-sidebar-content-title">
							{this.props.title}
						</div>
						<div className="wizard-sidebar-content-text">{this.props.text}</div>
					</div>

					<div className="wizard-sidebar-content-image">
						<img
							src={`./images/${this.props.image}.png`}
							srcSet={`./images/${this.props.image}.png 1x, ./images/${
								this.props.image
							}@2x.png 2x`}
							alt={this.props.title}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default WizardSidebar;
